// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2KYsL","boxTitle":"Qualiphy_boxTitle__1qFBl","box":"Qualiphy_box__16cgZ","toggleWrap":"Qualiphy_toggleWrap__1RYXk"};